export default __webpack_public_path__ + "static/media/image3.93f7bf1ba25ab75e6b938c8709c233f8.png";